module.exports = __webpack_public_path__ + "img/waimai-01.6150d466.jpg";